// dependancies
import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

// styles
import InputStyled from './Input.styled'
import ThemeProviderStyled from '../../../theme/ThemeProvider.styled'

/**
 *
 * @param {*} props
 * if the `icon` prop is passed in
 * the icon passed in using the `symbol` prop is displayed
 * a class of `input__with__symbol` is added to handle the styling of an input with an icon
 */

const Input = React.forwardRef((props, ref) => {
  const {
    id,
    type,
    name,
    change,
    keyup,
    keydown,
    keypress,
    focus,
    blur,
    value,
    required,
    error,
    disabled,
    icon,
    symbol,
    maxLength,
    defaultValue,
    min,
    placeHolder,
    covert,
    showNumberKeypad,
    ariaInvalid,
    ariaDescribedby,
  } = props
  return (
    <ThemeProvider theme={ThemeProviderStyled}>
      <InputStyled covert={covert}>
        {/* {used to add an icon to an input field pass icon as a prop to display } */}
        {icon && <div className="symbol">{symbol}</div>}
        <input
          autoComplete="off"
          id={id}
          data-testid={id}
          type={type}
          name={name}
          onChange={change}
          onKeyUp={keyup}
          onKeyDown={keydown}
          onKeyPress={keypress}
          onFocus={focus}
          onBlur={blur}
          required={required}
          error={error}
          disabled={disabled}
          value={value}
          className={icon && 'input__with__symbol'}
          maxLength={maxLength}
          defaultValue={defaultValue}
          min={min}
          placeholder={placeHolder}
          inputMode={showNumberKeypad && 'numeric'}
          aria-describedby={ariaDescribedby}
          aria-invalid={ariaInvalid}
          pattern={showNumberKeypad && 'd*'} /* eslint-disable-line */
          ref={ref}
        />
      </InputStyled>
    </ThemeProvider>
  )
})

// props validation
Input.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'tel', 'password', 'email', 'date'])
    .isRequired,
  name: PropTypes.string.isRequired,
  change: PropTypes.func,
  keyup: PropTypes.func,
  keydown: PropTypes.func,
  keypress: PropTypes.func,
  focus: PropTypes.func,
  blur: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.bool,
  symbol: PropTypes.string,
  maxLength: PropTypes.string,
  defaultValue: PropTypes.string,
  min: PropTypes.string,
  placeHolder: PropTypes.string,
  covert: PropTypes.bool,
  showNumberKeypad: PropTypes.bool,
  ariaDescribedby: PropTypes.string,
  ariaInvalid: PropTypes.string,
}

export default Input
